const CONSENT_KEY = 'sshop_tracking_consent';
const VISITOR_KEY = 'sshop:activity-visitor';
const VISIT_KEY = 'sshop:activity-visit';
const LAST_ACTIVE_KEY = 'sshop:activity-last-active';
const VISIT_IDLE_MS = 30 * 60 * 1000;

export function activityHeaders(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  try {
    if (window.localStorage.getItem(CONSENT_KEY) !== 'granted') return {};
    let visitor = window.localStorage.getItem(VISITOR_KEY);
    if (!visitor) {
      visitor = crypto.randomUUID();
      window.localStorage.setItem(VISITOR_KEY, visitor);
    }
    let visit = window.sessionStorage.getItem(VISIT_KEY);
    const last = Number(window.sessionStorage.getItem(LAST_ACTIVE_KEY) ?? 0);
    if (!visit || Date.now() - last > VISIT_IDLE_MS) {
      visit = crypto.randomUUID();
      window.sessionStorage.setItem(VISIT_KEY, visit);
    }
    window.sessionStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
    return {
      'X-Activity-Consent': 'granted',
      'X-Activity-Visitor': visitor,
      'X-Activity-Visit': visit,
      'X-Activity-Page': window.location.pathname,
    };
  } catch {
    return {};
  }
}

export function clearActivityIdentity(): void {
  try {
    window.localStorage.removeItem(VISITOR_KEY);
    window.sessionStorage.removeItem(VISIT_KEY);
    window.sessionStorage.removeItem(LAST_ACTIVE_KEY);
  } catch {
    /* storage may be disabled */
  }
}
